import { IBidCpmGuidanceRange } from '@/Interfaces/IBidCpmGuidanceRange';
import { numberToUsd } from '@/helpers/valueFormatter/numberFormatter.helpers';

const GUIDANCE_SPREAD = 0.1;

export const calculateBidCpmGuidance = (guidanceValues: (number | null | undefined)[]): IBidCpmGuidanceRange | null => {
  const values = guidanceValues.filter((value): value is number => Number.isFinite(value) && (value as number) > 0);

  if (!values.length) return null;

  const average = values.reduce((sum, value) => sum + value, 0) / values.length;

  return { min: average * (1 - GUIDANCE_SPREAD), max: average * (1 + GUIDANCE_SPREAD) };
};

export const formatBidCpmGuidance = ({ min, max }: IBidCpmGuidanceRange): string =>
  `${numberToUsd(min)} – ${numberToUsd(max)}`;
